import ActionTypes from '../constants/ActionTypes';

const initialState = {
  isFetching: false,
  didInvalidate: false,
  items: [],
  // totalRows: 0
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_TERMINAL:
      return {
        ...state,
        isFetching: true,
        didInvalidate: false
      }

    case ActionTypes.RECEIVE_TERMINAL:
      return {
        ...state,
        isFetching: false,
        didInvalidate: false,
        items: action.items,
        totalRows: action.items.DataCount,
        lastUpdated: action.receivedAt
      }
    default:
      return state
  }
}